import { useMutation, UseMutationOptions, useQueryClient } from "@tanstack/react-query";
import { Channel, ProviderConfig } from "@/types";
import { api, UnprocessableEntityError } from "@/utils/api";
import { camelize, underscore } from "@/utils/api-helpers";

export type UpdateChannelInput = {
  name: string;
  config?: ProviderConfig;
};

export const useUpdateChannel = (
  projectId: string,
  channelId: string,
  options: Omit<UseMutationOptions<Channel, UnprocessableEntityError, UpdateChannelInput, unknown>, "mutationFn"> = {}
) => {
  const queryClient = useQueryClient();

  return useMutation<Channel, UnprocessableEntityError, UpdateChannelInput, unknown>({
    mutationFn: async (input: UpdateChannelInput): Promise<Channel> => {
      const response = await api.patch<Channel>(`/projects/${projectId}/channels/${channelId}`, underscore(input));
      return camelize(response.data);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["projects", projectId, "channels"],
      });
      queryClient.invalidateQueries({
        queryKey: ["projects", projectId, "channels", channelId],
      });
    },
    ...options
  });
};
